import "./object-journals-list-skeleton.scss";
import { ObjectJournalsSkeleton } from "../object-journals-skeleton";

export const ObjectJournalsListSkeleton = () => {
  const skeletons = [1, 2, 3];

  return (
    <div className="object-journals-list-skeleton">
      {skeletons.map((item) => (
        <ObjectJournalsSkeleton key={item} />
      ))}
    </div>
  );
};
